import { CreditCard, LayoutDashboard, Receipt } from 'lucide-react';
import AnthropicIcon from '@/components/icons/Anthropic';
import DeepgramIcon from '@/components/icons/Deepgram';
import FireworksIcon from '@/components/icons/Fireworks';
import GoogleCloudIcon from '@/components/icons/GoogleCloud';
import ManyChatIcon from '@/components/icons/ManyChat';
import OpenAIIcon from '@/components/icons/OpenAI';
import TwilioIcon from '@/components/icons/Twilio';
import type { GetSidebarIconParams } from '../types';

const CUSTOM_PROVIDER_ID_PREFIX = 'custom_';

const getSidebarIcon = ({ key, size }: GetSidebarIconParams) => {
    if (key.startsWith(CUSTOM_PROVIDER_ID_PREFIX)) {
        return <Receipt size={size} />;
    }

    switch (key) {
        case 'overview':
            return <LayoutDashboard size={size} />;
        case 'gcp':
            return <GoogleCloudIcon size={size} />;
        case 'twilio':
            return <TwilioIcon size={size} />;
        case 'openai':
            return <OpenAIIcon size={size} />;
        case 'anthropic':
            return <AnthropicIcon size={size} />;
        case 'deepgram':
            return <DeepgramIcon size={size} />;
        case 'stripe':
            return <CreditCard size={size} />;
        case 'fireworks':
            return <FireworksIcon size={size} />;
        case 'manychat':
            return <ManyChatIcon size={size} />;
        default:
            return <Receipt size={size} />;
    }
};

export default getSidebarIcon;
